import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { EntityModel } from '@data-layer/models/entities';
import { enumEntityModelCode } from '@data-layer/enums/entities/enumEntityCode';
import { enumIdentifierQualifier } from '@data-layer/enums/common';

@Injectable({
  providedIn: 'root',
})
export class EntitiesRepository {
  constructor(private apiService: ApiService) {}

  public getEntity(entityId: number): Observable<EntityModel> {
    return this.apiService.get<EntityModel>(`${environment.url.prefixCustoms}v2/entities/${entityId}`);
  }

  public updateEntity(entityId: number, data: Partial<EntityModel>): Observable<EntityModel> {
    return this.apiService.put<EntityModel>(`${environment.url.prefixCustoms}v2/entities/${entityId}`, data);
  }

  public deleteEntity(entityId: number): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/entities/${entityId}`);
  }

  public createEntity(companyId: number, data: Partial<EntityModel>): Observable<EntityModel> {
    return this.apiService.post<EntityModel>(`${environment.url.companies}${companyId}/entities/`, data);
  }

  public searchByCompany(
    companyId: number,
    params: {
      type: enumEntityModelCode;
      name?: string;
      identifier?: string;
    },
    isUsed: boolean = false,
  ): Observable<EntityModel[]> {
    return this.apiService.get(`${environment.url.companies}${companyId}/entities`, { params }, { isShowLoader: false, isUsed });
  }

  public getFavoriteEntity(entityId: number): Observable<EntityModel> {
    return this.apiService.get<EntityModel>(`${environment.url.prefixCustoms}v2/favorite-entities/${entityId}`);
  }

  public createFavoriteEntity(companyId: number, data: Partial<EntityModel>): Observable<EntityModel> {
    return this.apiService.post<EntityModel>(`${environment.url.companies}${companyId}/favorite-entities/`, data);
  }

  public searchFavoriteByCompany(
    companyId: number,
    params: {
      type: enumEntityModelCode;
      name?: string;
      identifier?: string;
    },
    isUsed: boolean = false,
  ): Observable<EntityModel[]> {
    return this.apiService.get(`${environment.url.companies}${companyId}/favorite-entities`, { params }, { isShowLoader: false, isUsed });
  }

  public managementUpdate(entityId: number, data: Partial<EntityModel>): Observable<EntityModel> {
    return this.apiService.put<EntityModel>(`${environment.url.prefixCustoms}v2/management/entities/${entityId}`, data);
  }

  public managementDelete(entityId: number): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/management/entities/${entityId}`);
  }

  //TODO: check to remove all components that using this endpoint

  // public managementCreate(data: Partial<EntityModel>): Observable<EntityModel> {
  //   return this.apiService.post<EntityModel>(`${environment.url.prefixCustoms}v2/management/entities/`, data);
  // }

  public managementCreate(companyId: number, data: Partial<EntityModel>): Observable<EntityModel> {
    return this.apiService.post<EntityModel>(`${environment.url.prefixCustoms}v2/management/companies/${companyId}/entities`, data);
  }

  public managementSearch(params: {
    type: enumEntityModelCode;
    name?: string;
    identifier?: enumIdentifierQualifier;
  }): Observable<EntityModel[]> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/management/entities`, { params }, { isShowLoader: false });
  }
}
